import * as styles from './VerticalTextWithImage.module.scss'
import Heading from '../Heading/Heading'

const VerticalTextWithImage = ({ title, description, image, imageAlt }) => (
  <div className={styles.verticalTextWithImageContainer}>
    <div className={styles.verticalTextWithImage}>
      <Heading
        type="h3"
        headingSize="h2"
        className={styles.verticalTextWithImageTitle}>
        {title}
      </Heading>
      <div className={styles.verticalTextWithImageText}>{description}</div>
      <img
        className={styles.verticalTextWithImageImage}
        src={image}
        alt={imageAlt}
        width="840"
        height="280"
      />
    </div>
  </div>
)

export default VerticalTextWithImage
